/** SO-10 rail icon (eager, tiny): a toon ballot box with a card going in. */
import type { JSX } from 'preact';

export function BallotIcon({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M11 4.5h10.5v11H11z" fill="#fff8ec" stroke="#4a2c2a" stroke-width="2.2" stroke-linejoin="round" />
      <path d="M13.5 8.5l2 2 3.6-3.8" fill="none" stroke="#2ec4b6" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 14.5h22l-1.6 13H6.6z" fill="#ff6b5b" stroke="#4a2c2a" stroke-width="2.4" stroke-linejoin="round" />
      <path d="M9.5 14.5h13" stroke="#4a2c2a" stroke-width="3" stroke-linecap="round" />
      <path d="M11 20.5h10" stroke="#fff8ec" stroke-width="2" stroke-linecap="round" opacity=".7" />
    </svg>
  );
}
